const axios = require("axios");
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
const qs = require("qs");
// const store = require('@/lib/localStorage')['default']
// const sessionStore = require('@/lib/sessionStorage')['default']
import { internalStore } from "@/utils/LLM/localStore";
const instance = axios.create({
  headers: { "Content-Type": "application/x-www-form-urlencoded;charset=utf-8" },
});
// 请求拦截器 - 每次请求前自动添加 token
instance.interceptors.request.use(
  (config) => {
    // 从任意地方获取最新 token（localStorage、Vuex、Pinia、内存等）
    const loginData = internalStore.get("loginData");

    if (loginData) {
      config.headers['Token'] = loginData.token;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
const instance2 = axios.create({
  headers: { "Content-Type": "application/json;charset=utf-8" },
});
let post = (url, params) => {
  // let auth = {}
  // if (params && params['token']) {
  //   auth['Token'] = params['token']
  // } else {
  //   auth = JSON.parse(sessionStore.get('auth-user'))
  //   if (!auth) {
  //     auth = {}
  //   }
  // }
  // console.log(auth.Token)
  // token: auth.Token,
  return (
    instance
      .post(url, qs.stringify({ ...params }))
      // return instance.post(url, qs.stringify({Token: 'Zjc4ZTRlN2YwNmNhMjAwZjg1ZGRmZWQ0NjRhMzc5NTE=', ...params}))
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
  );
};
let get = (url, params) => {
  return instance
    .get(url + "?" + qs.stringify({ ...params }))
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((e) => {
      console.log(e);
    });
};
let postJSON = (url, params) => {
  return instance2.post(url, { ...params }).then((res) => {
    if (res.status === 200) {
      return res.data;
    }
  });
};
export default {
  post,
  get,
  postJSON,
};
